<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4.h6.basic800--text {{ this.parentCashier ? $t('edit_new_cashier') : $t('add_new_cashier') }}
      v-divider.basic400
      v-card-text.pa-4
        v-form(ref="form")
          .label.basic600--text.text-uppercase {{ $t('role') }}
          v-select.mt-2(v-model="form.role" :items='memberRoles' item-value="id" item-text="name" dense outlined height="40" background-color="basic200" :rules="rules.not_empty_select" append-icon="mdi-chevron-down" readonly)
          .label.basic600--text.text-uppercase {{$t('username.label')}}
          v-text-field.mt-2(v-model='form.username' :placeholder="$t('username.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
          .label.basic600--text.text-uppercase {{$t('password.label')}}
          v-text-field.mt-2(v-model='form.password' :placeholder="$t('password.placeholder')" type="password" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
      
      v-card-actions.pb-4.px-4
        v-spacer
        v-btn(text='', @click='showModal = false' :disabled="loading" depressed height=32)
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn(color='textColorAccent' depressed height=32 @click='clickSave' :loading="loading")
          .button-AA-small.basic100--text| {{ $t('add') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AddNewCashier',
  props: ['open', 'company', 'parentCashier'],
  data: () => ({
    loading: false,
    form: {
      role: 'cashier'
    },
    memberRoles: [
      {
        name: 'Cashier',
        id: 'cashier'
      }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      not_empty_select: [v => !!v || 'This field is required'],
    },
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    cashier: {
      get() {
        return this.parentCashier
      },
      set(newValue) {
        this.$emit('update:parentCashier', newValue)
      }
    }
  },
  mounted () {
    if (this.cashier) {
      this.$set(this.form, 'username', this.cashier.username)
      this.$set(this.form, 'id', this.cashier.id)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.form.id) {
        this.$axios.patch(`/pos/${this.company.slug}/staffs/${this.form.id}`, this.form)
          .then(() => {
            this.showMessage(['success', this.$t('success_message.new_cashier_created')])
            this.$emit('refresh')
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$axios.post(`/pos/${this.company.slug}/staffs`, this.form)
          .then(() => {
            this.showMessage(['success', this.$t('success_message.new_cashier_created')])
            this.$emit('refresh')
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "name": {
      "label": "Name",
      "placeholder": "Enter name"
    },
    "username": {
      "label": "Username",
      "placeholder": "Enter username"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter password"
    }
  },
  "id": {
    "name": {
      "label": "Nama",
      "placeholder": "Nama Member"
    },
    "username": {
      "label": "Username",
      "placeholder": "Enter username"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter password"
    }
  }
}
</i18n>